/* ==============================================
   QUICK VIEW - Boutique Nuance
   ============================================== */

class QuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.quick-view-modal__close');
    this.overlay = this.querySelector('.quick-view-modal__overlay');
    this.bindEvents();
  }

  bindEvents() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open(productHandle) {
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    this.loadProduct(productHandle);
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    const contentInner = this.querySelector('.quick-view-modal__product');
    if (contentInner) {
      contentInner.innerHTML = '<div class="quick-view-loading"><div class="loading-spinner"></div></div>';
    }
  }

  async loadProduct(handle) {
    const contentInner = this.querySelector('.quick-view-modal__product');
    if (!contentInner) return;

    contentInner.innerHTML = '<div class="quick-view-loading"><div class="loading-spinner"></div></div>';

    try {
      const response = await fetch(`/products/${handle}?section_id=quick-view-content`);
      if (!response.ok) throw new Error('Product not found');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const content = doc.querySelector('.quick-view-product-content');

      if (content) {
        contentInner.innerHTML = content.innerHTML;
        this.initGallery();
        this.initQuantityButtons();
      }
    } catch (error) {
      console.error('Quick View error:', error);
      contentInner.innerHTML = `
        <div class="quick-view-error">
          <p>Une erreur est survenue.</p>
          <a href="/products/${handle}" class="button">Voir le produit</a>
        </div>
      `;
    }
  }

  initGallery() {
    const thumbnails = this.querySelectorAll('.quick-view-thumbnail');
    const mainImage = this.querySelector('.quick-view-main-image img');
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImage) {
          mainImage.src = thumb.dataset.fullSrc;
          mainImage.srcset = thumb.dataset.srcset || '';
        }
      });
    });
  }

  initQuantityButtons() {
    const qtyButtons = this.querySelectorAll('.quick-view-qty-btn');
    qtyButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('.quick-view-qty-input');
        const currentValue = parseInt(input.value) || 1;
        if (this.dataset.action === 'increase') {
          input.value = currentValue + 1;
        } else if (this.dataset.action === 'decrease' && currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    });
  }
}

customElements.define('quick-view-modal', QuickViewModal);

// Open quick view modal
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.quick-view-trigger');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    const modal = document.querySelector('quick-view-modal');
    if (modal) {
      modal.open(trigger.dataset.productHandle);
    }
  }
});

// ADD TO CART - Using mousedown to fire before any click interceptors
document.addEventListener('mousedown', function(e) {
  const btn = e.target.closest('.qv-add-cart-btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  // Prevent any other handlers
  e.preventDefault();
  e.stopPropagation();

  // Get quantity
  const modal = document.querySelector('quick-view-modal');
  const qtyInput = modal ? modal.querySelector('.quick-view-qty-input') : null;
  const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

  // Update button
  btn.disabled = true;
  btn.textContent = 'Ajout...';

  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
  })
  .then(r => r.json())
  .then(data => {
    if (data.status && data.status !== 200) {
      throw new Error(data.description || 'Erreur');
    }
    btn.textContent = 'Ajouté!';
    // RELOAD PAGE
    setTimeout(function() {
      window.location.reload(true);
    }, 300);
  })
  .catch(err => {
    btn.disabled = false;
    btn.textContent = 'Ajouter au panier';
    alert('Erreur: ' + err.message);
  });
}, true);
